import { useQuery } from 'react-query'; // ✅ use this with v3
import axiosInstance from './axiosInstance';

const fetchModulesAnalytics = async () => {
  const response = await axiosInstance.get('/super-admin/dashboard/modules-analytics');
  return response.data;
};

export const useGetModulesAnalytics = () => {
  return useQuery('modules-analytics', fetchModulesAnalytics); // ✅ v3 syntax
};
